import { TemporaryTeacherResponse } from '../../apis/open-teaching-api/models/temporary-teacher-response';

/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: chen
 *  创建时间: 2026-08-11 09:05
 *  文件名: src/pages/other-resource-list/types.ts
 *  功能描述:
 */
export enum VideoResourceType {
  CLASS_RECORD = '1',
  PREPARE_RECORD = '2',
  PREPARE_PPT = '3',
}

export const videoResourceTypes = [
  {
    name: '课堂资料',
    value: VideoResourceType.CLASS_RECORD,
  },
  // 产品付雨琪要求备课资料不展示了
  // {
  //   name: '备课资料',
  //   value: VideoResourceType.PREPARE_RECORD,
  // },
  // 产品要求提前PPT不继续往后做
  // {
  //   name: '提前PPT',
  //   value: VideoResourceType.PREPARE_PPT,
  // },
];

// 提前PPT项
export interface PreparePPTItem {
  id: string;
  name: string;
  teachers: TemporaryTeacherResponse[];
  releaseTime: number;
  highLightName: string;
}

// 备课资料项
export interface PrepareRecordItem {
  applyStartTime: number;
  id: string;
  name: string;
  resourceType: string; // "PREPARE_LESSON_MEMOIR"
  resourceTypeName: string;
  teacherId: string;
  teacherName: string;
}

// 课堂资料项
export interface ClassRecordItem {
  id: string;
  name: string;
  teacherId: string;
  teacherName: string;
  releaseTime: number;
  applyStartTime: number;
}

interface HighLightName {
  highLightName?: string;
}

export type VideoResourceItem<T extends VideoResourceType = VideoResourceType> =
  T extends VideoResourceType.PREPARE_PPT
    ? PrepareRecordItem & HighLightName
    : ClassRecordItem & HighLightName;
